/* eslint-disable react/require-default-props */
import React, {
  PropsWithChildren,
} from 'react';
import classNames from 'classnames';
import styles from './Options.module.css';
import { BaseProps } from '../../../../types';

function OptionsContainer({
  children, selected, className, disabled, onClick, ...props
}:
PropsWithChildren<BaseProps & {
  selected: boolean,
  disabled?: boolean,
  onClick?: any,
  className?: string
}>) {
  return (
    <div
      {...props}
      role="none"
      className={classNames(
        className,
        styles.container,
        styles.optionContainer,
        {
          [styles.optionContainerSelected]: selected,
          [styles.disabled]: disabled,
        },
      )}
      onClick={disabled ? () => { } : onClick}
    >
      {children}
    </div>

  );
}
export default OptionsContainer;
